// TODO: Refactor
import { FC, useState } from 'react';
import { PlatformName, UseCase } from '@app/app/analytics/types';
import { analytics } from '@app/app/analytics';
import { usePersistedUseCaseStore } from '@app/app/persist';
import { COOKIE_KEY, cookieUtils } from '@app/app/cookie';

type QuizContent = {
  title: string;
  description: string;
  quest: string;
  skipBtn: string;
  submit: string;
  items: string[];
  values: UseCase[];
};

const QUIZ_CONTENT: QuizContent = {
  title: 'Finish registration',
  description: `Just one step before registration! \n Please answer to help us get to know you better..`,
  quest: 'What’s your presentation’s purpose?',
  skipBtn: 'Skip question',
  submit: 'Submit and register',
  items: [
    'Teaching and training',
    'HR and People development',
    'Marketing',
    'Sales',
    'Management',
    "I'm a student",
    'Other category',
  ],
  values: [
    'teaching_and_training',
    'hr_and_people_development',
    'marketing',
    'sales',
    'management',
    'im_a_student',
    'other_category',
  ],
};

export const RegisterQuiz: FC<{ close: () => void; isLoading: boolean }> = (props) => {
  const { close, isLoading } = props;
  const [activeItem, setActiveItem] = useState<number | null>(null);
  const [isFetching, setIsFetching] = useState(false);

  const { setUseCase } = usePersistedUseCaseStore();
  const submit = () => {
    if (activeItem === null) return;
    const answer = QUIZ_CONTENT.values[activeItem];
    setIsFetching(true);
    setUseCase(answer);
    cookieUtils.set(COOKIE_KEY.useCase, answer);
    analytics.emitEvent('onboarding_submit', {
      [PlatformName.GTM]: { usecase: answer },
    });
    close?.();
  };
  function skipQuizHandler() {
    setUseCase('skip');
    cookieUtils.set(COOKIE_KEY.useCase, 'skip');

    analytics.emitEvent('onboarding_submit', {
      [PlatformName.GTM]: { usecase: 'skip' },
    });
    close?.();
  }

  return (
    <div className="auth_quiz__container">
      <div className="auth_title">{QUIZ_CONTENT.title}</div>
      <div className="auth_quiz_text">{QUIZ_CONTENT.description}</div>
      <div className="auth_quiz_quest">{QUIZ_CONTENT.quest}</div>
      <ul className="auth_quiz_items">
        {QUIZ_CONTENT.items.map((item, i) => (
          <li
            className={'auth_quiz_item' + (activeItem === i ? ' active' : '')}
            key={i}
            onClick={() => {
              setActiveItem(i);
            }}
          >
            {item}
          </li>
        ))}
      </ul>
      <div className="auth_quiz_btn__wrapper">
        <div>
          <button
            type="button"
            className="auth_quiz_skip_btn"
            onClick={skipQuizHandler}
            disabled={isFetching || isLoading}
          >
            {QUIZ_CONTENT.skipBtn}
          </button>
        </div>
        <button
          type="button"
          className={
            'main_btn auth_quiz_btn' +
            (activeItem === null || isFetching || isLoading ? ' auth_quiz_btn__disabled' : '')
          }
          disabled={activeItem === null || isFetching || isLoading}
          onClick={submit}
        >
          {QUIZ_CONTENT.submit}
        </button>
      </div>
    </div>
  );
};
